import styled from "@emotion/styled";
export const ButtonContainer = styled.div`
  display: flex;
  margin-top: 1rem;
`;
